import { React, useState } from 'react';
import './oralink.css';
import back from "../../img/Abstract.png";
import logo from "../../img/oralink_logo.png";
import oralinkBg from "../../img/oralink_bckg.png";
import karen from "../../img/OraLink_Medguru-Photoroom.png"

const OraLinkSection = () => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div className="container">
      <div
        className="oralink-descr"
        // style={{
        //   backgroundImage: `url(${oralinkBg})`,
        //   backgroundRepeat: 'no-repeat',
        //   backgroundSize: 'cover',
        //   backgroundPosition: 'center',
        //   borderRadius: "27px",
        //   marginTop: "20px",
        //   padding: '60px 20px', // Добавим отступы
        //   minHeight: "50vw"
        // }}
      >
        <div className="container" style={{ maxWidth: '100%', textAlign: 'center', color: '#fff' }}>
          <h2 className="oralink-text" style={{ fontSize: 'clamp(24px, 5vw, 42px)', lineHeight: '1.3' }}>
            OraLink решит ваши проблемы с базой
          </h2>
          <p style={{ fontSize: 'clamp(16px, 3vw, 20px)', marginTop: '10px' }}>
            Выстраиваем цифровую гигиену базы для наших партнёров
          </p>
        </div>
      </div>
      

      <div className="omnitouch container flex" style={{backgroundImage: `url(${back})`, backgroundRepeat: "no-repeat", backgroundSize: "contain", backgroundPosition: "center"}}>
          <span className="oralink-dscr">
              <i style={{color: "#503ba4"}}>OraLink&nbsp;</i>&mdash; это универсальная база данных врачей и&nbsp;медучреждений, 
              собранная вручную нашей собственной командой. 
              Это не&nbsp;просто список телефонов, это полноценный инструмент для эффективной коммуникации и&nbsp;валидации базы.
          </span>
      </div>

      <div className="oragen-adv">
            <ul className="adv-list list-reset flex">
                <li className="adv-list-item-link">
                    <h3 className="adv-item-title">Единая платформа</h3>
                    <p className="adv-item-descr">
                      Проверенные данные о врачах (HCP) и медучреждениях (HCO). 
                    </p>
                </li>
                <li className="adv-list-item-link">
                    <h3 className="adv-item-title">Верификация</h3>
                    <p className="adv-item-descr">
                      Автоматизированная верификация через открытые источники + экспертная проверка.
                    </p>
                </li>
                <li className="adv-list-item-link">
                    <h3 className="adv-item-title">Надежная интеграция</h3>
                    <p className="adv-item-descr">
                      Полная интеграция с CRM и другими системами.
                    </p>
                </li>
                <li className="adv-list-item-link">
                    <h3 className="adv-item-title">Профайлинг врача</h3>
                    <p className="adv-item-descr">
                        Дополните профайл врача его диджитал портретом
                        (эксклюзивные данные Medtouch)
                    </p>
                </li>
            </ul>
        </div>

        <div className="oralink-quote-fullwidth">
          <div className="oralink-quote-wrapper container">
            <img src={karen} alt="Карен Аютов" className="oralink-quote-image" />
            <div className="oralink-quote-text">
              <blockquote className="oralink-quote">
                “Мы не просто предоставляем данные. Мы помогаем нашим клиентам выстроить 
                эффективную коммуникацию с медицинским сообществом.”
                <div className="oralink-author">— Карен Аютов, IT директор Medguru</div>
              </blockquote>
            </div>
          </div>
        </div>

        <div className="oralink-specialists-block">
          <div className="specialists-count">
            <span className="count-number">&gt;600 000</span>
            <span className="count-description">специалистов для вашей<br />эффективной работы!</span>
          </div>
          <div className="specialists-list">
            <ul>
              <li>Онкологи</li>
              <li>Акушеры-гинекологи</li>
              <li>Аллергологи-иммунологи</li>
              <li>Хирурги</li>
            </ul>
            <ul>
              <li>Неврологи</li>
              <li>Кардиологи</li>
              <li>Терапевты</li>
              <li>Педиатры</li>
            </ul>
            <span className="and-others">И другие</span>
          </div>
        </div>

        <div className="flex orlink-btn">
            <a className="description-btn btn-reset flex" 
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                href="/contacts">
                <span style={{display: "flex", alignItems: "center", fontSize: "18px"}}>связаться с нами</span>
                <svg width="27" height="28" className={isHovered === true ? "arrow active" : "arrow"} viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1.03455L25.5 26.0303M25.5 26.0303V0.969604M25.5 26.0303H0.5" stroke="white" strokeWidth="2"/>
                </svg>
            </a>
        </div>
    </div>
  );
};

export default OraLinkSection;
